import { render } from "./ClinicLogo.vue?vue&type=template&id=6c43a83a&scoped=true&ts=true"
import script from "./ClinicLogo.vue?vue&type=script&lang=ts"
export * from "./ClinicLogo.vue?vue&type=script&lang=ts"

import "./ClinicLogo.vue?vue&type=style&index=0&id=6c43a83a&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c43a83a"]])

export default __exports__